import { JSONWidgetType as TeaserStandardVerticalVideoJSONWidgetType } from '@widgets/TeaserStandardVerticalVideo'

import {
  ExecuteQuery,
  getAureusBatchRecommendations,
  getSectionWithAureusEnvironment,
  Purpose,
  QueryFactory,
} from '..'

interface AureusVideoRecommendationItem extends Record<string, unknown> {
  aureusOfferId: string
  articleID: string
  teasers: {
    standardVerticalVideo: TeaserStandardVerticalVideoJSONWidgetType
  }
}

export const queryKey = 'embedded-videos'

export const createQuery = (({
  purpose = 'reference',
  contentBlacklist,
}: {
  purpose?: Purpose
  contentBlacklist: string
}) =>
  ({
    [queryKey]: {
      resultsLimit: 8,
      context: {
        section: getSectionWithAureusEnvironment(
          'polaris-article-video-player',
        ),
        purpose,
        contentBlacklist,
      },
    },
  }) as const) satisfies QueryFactory<typeof queryKey>

export const executeQuery = (async (
  queryOptions: Parameters<typeof createQuery>[0],
  options?: Record<string, unknown>,
) => {
  try {
    const result = (
      await getAureusBatchRecommendations<
        typeof queryKey,
        AureusVideoRecommendationItem
      >(createQuery(queryOptions), options)
    ).results[queryKey]

    if (!Array.isArray(result?.recommendations)) {
      return
    }

    return result.recommendations
  } catch (err) {
    console.error(err)
  }
}) satisfies ExecuteQuery<typeof queryKey>
